<div class="ui-g">
  <div class="ui-g-12">
    <ng-template #questionContainer></ng-template>
  </div>
</div>
